import type { FeatureCollection, Polygon } from 'geojson';

const EARTH_RADIUS_M = 6378137;

/**
 * Gera um polígono geodésico circular ao redor de (lng, lat) com raio em metros.
 * Aproximação simples (esfera, não elipsóide), boa o suficiente pra raios pequenos
 * tipo precisão de GPS (~50m).
 */
export function circlePolygon(
  lng: number,
  lat: number,
  radiusMeters: number,
  points = 64,
): FeatureCollection<Polygon> {
  const coords: [number, number][] = [];
  const latRad = (lat * Math.PI) / 180;
  const dLatBase = (180 / Math.PI) / EARTH_RADIUS_M;
  const dLngBase = dLatBase / Math.cos(latRad);

  for (let i = 0; i <= points; i++) {
    const angle = (i / points) * 2 * Math.PI;
    const dx = radiusMeters * Math.cos(angle);
    const dy = radiusMeters * Math.sin(angle);
    coords.push([lng + dx * dLngBase, lat + dy * dLatBase]);
  }

  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: { radius: radiusMeters },
        geometry: { type: 'Polygon', coordinates: [coords] },
      },
    ],
  };
}
